import React from 'react'
import injectSheet from 'react-jss'
import styles from './wizard.styles'
import { ModalHeader, ModalContent } from 'pobble-components/dist/modal'
import Introduction from './steps/introduction/introduction.container'
import Resolution from './steps/resolution/resolution.container'
import Conclusion from './steps/conclusion/conclusion.container'

const Wizard = ({
  classes,
  step,
  noMoreStudents,
  onIntroScreen,
  onResolutionScreen,
  onNextStep
}) => {
  return (
    <div className={classes.container}>
      <ModalHeader className={classes.modalHeader}>
        We're connecting Pobble to your MIS
      </ModalHeader>
      <ModalContent legacy className={classes.modalContent}>
        <div className={classes.content}>
          {!noMoreStudents && (
            <>
              {onIntroScreen && <Introduction />}
              {onResolutionScreen && <Resolution />}
            </>
          )}
          {noMoreStudents && <Conclusion />}
        </div>
      </ModalContent>
    </div>
  )
}

export default injectSheet(styles)(Wizard)
